module.exports = __webpack_public_path__ + "static/media/Survival.0f75142d.jpeg";